import { useQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { meetingClient } from '../client/meetingClient';


export type Params = {
    id: number;
};

type Options = {
    enabled: boolean
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useMeetingQuery = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useQuery({
    queryKey: [cacheKeys.getMeeting, params.id],
    queryFn: () => meetingClient.getMeeting(params),
    enabled: options.enabled !== undefined ? options.enabled : defaultOptions.enabled,
  });

  return {
    ...rest,
    meeting: data,
  };
};
